import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '../store'
Vue.use(VueAxios, axios)

if (window.localStorage) {
  let uri = 'https://admin.weddingsung.com/api/'
  let downData = true
  let Today = new Date()
  Today = Today.getFullYear() + '-' + (Today.getMonth() + 1) + '-' + Today.getDate()
  let dataTime = new Date(window.localStorage.getItem('dataTime'))
  dataTime = dataTime.getFullYear() + '-' + (dataTime.getMonth() + 1) + '-' + dataTime.getDate()
  // console.log(Today + '----' + dataTime)
  if (dataTime === null || Today !== dataTime) {
    downData = true
  }

  let slide = window.localStorage.getItem('slide')
  if (slide === '' || slide === 'null' || downData === true) {
    axios.get(uri + 'Home/getData').then((res) => {
      let data = res.data
      // console.log(res)
      store.dispatch('SET_SLIDE', data.slide)
      store.dispatch('SET_SONG_CATEGORY', data.song_category)
      store.dispatch('SET_SONG_TAG_LANG', data.tag_lang)
      store.dispatch('SET_SONG_TAG_TEMPO', data.tag_tempo)
      store.dispatch('SET_SONG_LATEST', data.song_latest)
      store.dispatch('SET_SONG_SPECIAL', data.song_special)
      store.dispatch('SET_SONG_SHARE', data.share)
      store.dispatch('SET_PARTNER_CATEGORY', data.partner_category)
      store.dispatch('SET_ACTIVITY', data.activity)
      store.dispatch('SET_HOT', data.hots)
      store.dispatch('SET_ARTICLE', data.article)
    }).catch((response) => {
      console.log('load fail')
    })
  } else {
    let songCategory = window.localStorage.getItem('songCategory')
    let songTagLang = window.localStorage.getItem('songTagLang')
    let songTagTempo = window.localStorage.getItem('songTagTempo')
    let songLatest = window.localStorage.getItem('songLatest')
    let songSpecial = window.localStorage.getItem('songSpecial')
    let songShare = window.localStorage.getItem('songShare')
    let partnerCategory = window.localStorage.getItem('partnerCategory')
    let activity = window.localStorage.getItem('activity')
    let hot = window.localStorage.getItem('hot')
    let article = window.localStorage.getItem('article')
    store.dispatch('SET_SLIDE', JSON.parse(slide))
    store.dispatch('SET_SONG_CATEGORY', JSON.parse(songCategory))
    store.dispatch('SET_SONG_TAG_LANG', JSON.parse(songTagLang))
    store.dispatch('SET_SONG_TAG_TEMPO', JSON.parse(songTagTempo))
    store.dispatch('SET_SONG_LATEST', JSON.parse(songLatest))
    store.dispatch('SET_SONG_SPECIAL', JSON.parse(songSpecial))
    store.dispatch('SET_SONG_SHARE', JSON.parse(songShare))
    store.dispatch('SET_PARTNER_CATEGORY', JSON.parse(partnerCategory))
    store.dispatch('SET_ACTIVITY', JSON.parse(activity))
    store.dispatch('SET_HOT', JSON.parse(hot))
    store.dispatch('SET_ARTICLE', JSON.parse(article))
  }

  let token = window.localStorage.getItem('token')
  if (token !== '' && token !== 'null') {
    let user = {
      userId: localStorage.getItem('userId'),
      userName: localStorage.getItem('userName'),
      userEmail: localStorage.getItem('userEmail'),
      token: localStorage.getItem('token')
    }
    store.dispatch('LOGIN', user)
  }
} else {
  console.log('不支援暫時存取服務。')
}




// WEBPACK FOOTER //
// ./src/api/index.js